export var createEmptyClient = function (uuid) {
    return {
        uuid: uuid(),
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        image: "",
        pets: [],
        notes: "",
        active: true,
        blocked: false,
        authorizedContacts: [],
        temporalEmail: true,
        tags: {
            positive: [],
            negative: []
        },
        destroyable: true,
        notifications: {
            email: true,
            phone: true,
            marketing: true,
        },
        customQuestionResponses: [],
        hasActiveMembership: false,
    };
};
export var createEmptyContact = function (uuid) {
    return {
        uuid: uuid(),
        firstName: "",
        lastName: "",
        phone: "",
        emergencyContact: false,
    };
};
